import LText from "@components/LText";
import Button from "../common/Button";
import LIcon from "@components/LIcon";
import useValidatedExternalUrl from "../../utils/useValidatedExternalUrl";

const PreviewExternal = ({
  accessId,
  extLinks,
}: {
  accessId: string;
  extLinks: string[];
}) => {
  const open = useValidatedExternalUrl(extLinks, { accessId });
  return (
    <Button.Button
      onPress={open}
      sentryEventName="AccessDetail.PreviewExternal"
      bg="whiteTranslucent20"
    >
      <LIcon colors={{ color: "#FFFFFF80" }} name="extlink" size={16} />
      <LText variant="Caption/C1/Medium" color="white">
        Preview
      </LText>
    </Button.Button>
  );
};

export default PreviewExternal;
